import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';

import { useMutation } from '@sorare/core/src/hooks/graphql/useMutation';

import type {
  RestartTasksTrackMutation,
  RestartTasksTrackMutationVariables,
} from './__generated__/useRestartTasksTrck.graphql';

const RESTART_TASKS_TRACK_MUTATION = gql`
  mutation RestartTasksTrackMutation($input: restartTasksTrackInput!) {
    restartTasksTrack(input: $input) {
      newTask {
        id
      }
      errors {
        code
        message
      }
    }
  }
` as TypedDocumentNode<
  RestartTasksTrackMutation,
  RestartTasksTrackMutationVariables
>;

export const useRestartTasksTrck = () => {
  return useMutation(RESTART_TASKS_TRACK_MUTATION, {
    showErrorsWithSnackNotification: true,
  });
};
